import React from 'react';

const NoUsersFound = () => {
  return <div>Aucun utilisateur ne correspond à la recherche</div>;
};

export default NoUsersFound;
